import { S3UploadPolicy } from '../apis/Documents/DocumentApi.ts';

/**
 * POST a file directly to S3 using a pre-signed POST policy returned by the API.
 * Shared by the clinic logo and invitation-PDF upload flows so the form-field
 * assembly never drifts.
 */
export async function uploadFileToS3(policy: S3UploadPolicy, file: File): Promise<void> {
    const formData = new FormData();
    formData.append('key', policy.key);
    formData.append('policy', policy.policy);
    formData.append('x-amz-algorithm', policy['x-amz-algorithm']);
    formData.append('x-amz-credential', policy['x-amz-credential']);
    formData.append('x-amz-date', policy['x-amz-date']);
    formData.append('x-amz-signature', policy['x-amz-signature']);
    formData.append('file', file);

    const response = await fetch(policy.url, { method: 'POST', body: formData });
    if (!response.ok) {
        throw new Error(`S3 upload failed (${response.status})`);
    }
}
